const globals = {
  html: {
    scrollBehavior: "auto",
  },
  body: {
    backgroundColor: "#1a1a1a !important",
    color: "#ccc",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "h1, h2, h3, h4, h5, h6": {
    color: "#fff !important",
  },

  /* Paper / Cards */
  ".MuiPaper-root": {
    backgroundColor: "rgba(30,30,30,0.95) !important",
    color: "#ccc !important",
    backgroundImage: "none !important",
    border: "1px solid rgba(255,255,255,0.06) !important",
    borderRadius: "2px !important",
  },

  /* Tables */
  ".MuiTableCell-root:first-of-type": {
    paddingLeft: "10px !important",
  },
  ".MuiTableCell-root": {
    borderColor: "rgba(255,255,255,0.03) !important",
    color: "#ccc !important",
    fontSize: "12px !important",
    borderBottom: "1px solid rgba(255,255,255,0.03) !important",
    padding: "8px 4px !important",
    background: "transparent !important",
  },
  ".MuiTable-root": {
    borderCollapse: "separate !important",
    borderSpacing: "0 !important",
  },
  ".MuiTableHead-root": {
    background: "transparent !important",
  },
  ".MuiTableBody-root .MuiTableRow-root": {
    background: "transparent !important",
    transition: "background 0.15s",
  },
  ".MuiTableBody-root .MuiTableRow-root:hover": {
    background: "rgba(255,255,255,0.02) !important",
  },
  ".MuiTableContainer-root": {
    background: "transparent !important",
    boxShadow: "none !important",
  },
  ".MuiTableCell-head": {
    color: "#C29717 !important",
    fontSize: "10px !important",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    fontWeight: "400 !important",
    borderBottom: "1px solid rgba(255,255,255,0.06) !important",
    padding: "6px 4px !important",
  },
  ".MuiTableRow-root:hover": {
    backgroundColor: "rgba(255,255,255,0.02) !important",
  },

  /* Inputs */
  ".MuiInputBase-root": {
    color: "#fff !important",
    fontSize: "13px !important",
    backgroundColor: "#2a2a2a !important",
  },
  ".MuiInputLabel-root": {
    color: "#666 !important",
    fontSize: "12px !important",
  },
  ".MuiInputLabel-root.Mui-focused": {
    color: "#C29717 !important",
  },
  ".MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255,255,255,0.18) !important",
  },
  ".MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255,255,255,0.2) !important",
  },
  ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#C29717 !important",
    borderWidth: "1px !important",
  },

  /* Select / Autocomplete */
  ".MuiAutocomplete-paper": {
    backgroundColor: "#252525 !important",
    border: "1px solid rgba(255,255,255,0.08) !important",
  },
  ".MuiAutocomplete-option": {
    color: "#ccc !important",
    fontSize: "12px !important",
  },
  ".MuiAutocomplete-option:hover": {
    backgroundColor: "rgba(194,151,23,0.1) !important",
  },
  ".MuiAutocomplete-option[aria-selected='true']": {
    backgroundColor: "rgba(194,151,23,0.15) !important",
  },
  ".MuiMenuItem-root": {
    color: "#ccc !important",
    fontSize: "12px !important",
  },
  ".MuiMenuItem-root:hover": {
    backgroundColor: "rgba(194,151,23,0.1) !important",
  },
  ".MuiSelect-icon": {
    color: "#666 !important",
  },

  /* Buttons */
  ".MuiButton-root": {
    boxShadow: "none !important",
    textTransform: "none !important",
    fontSize: "12px !important",
    letterSpacing: "0.5px",
  },
  ".MuiButton-contained": {
    backgroundColor: "rgba(194,151,23,0.15) !important",
    color: "#C29717 !important",
    border: "1px solid rgba(194,151,23,0.3) !important",
  },
  ".MuiButton-contained:hover": {
    backgroundColor: "rgba(194,151,23,0.25) !important",
  },
  ".MuiButton-outlined": {
    borderColor: "rgba(255,255,255,0.12) !important",
    color: "#aaa !important",
  },
  ".MuiButton-outlined:hover": {
    borderColor: "rgba(255,255,255,0.3) !important",
    color: "#fff !important",
    backgroundColor: "transparent !important",
  },

  /* Dialogs */
  ".MuiDialog-paper": {
    backgroundColor: "#1e1e1e !important",
    border: "1px solid rgba(255,255,255,0.08) !important",
  },
  ".MuiDialogTitle-root": {
    color: "#fff !important",
    fontSize: "14px !important",
  },

  /* Tabs */
  ".MuiTab-root": {
    color: "#666 !important",
    fontSize: "11px !important",
    textTransform: "uppercase !important",
    letterSpacing: "1px !important",
    minHeight: "36px !important",
  },
  ".MuiTab-root.Mui-selected": {
    color: "#fff !important",
  },
  ".MuiTabs-indicator": {
    backgroundColor: "#C29717 !important",
    height: "1px !important",
  },

  /* Dividers */
  ".MuiDivider-root": {
    borderColor: "rgba(255,255,255,0.04) !important",
  },

  /* Badges */
  ".MuiBadge-badge": {
    fontSize: "10px !important",
    fontWeight: "400 !important",
    letterSpacing: "0.3px",
  },

  /* Icons */
  ".MuiSvgIcon-root": {
    color: "inherit !important",
  },
  ".MuiTypography-button": {
    color: "#fff !important",
  },
  ".MuiIconButton-root": {
    color: "#888 !important",
  },
  ".MuiIconButton-root:hover": {
    color: "#fff !important",
    backgroundColor: "rgba(255,255,255,0.05) !important",
  },

  /* Chips */
  ".MuiChip-root": {
    borderColor: "rgba(255,255,255,0.1) !important",
    fontSize: "10px !important",
  },

  /* Pagination */
  ".MuiPaginationItem-root": {
    color: "#888 !important",
    borderColor: "rgba(255,255,255,0.1) !important",
  },
  ".MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "rgba(194,151,23,0.15) !important",
    color: "#C29717 !important",
  },

  /* Circular progress */
  ".MuiCircularProgress-root": {
    color: "#C29717 !important",
  },

  /* Scrollbar */
  ".forte-spin": {
    width: "34px",
    height: "34px",
    position: "relative",
    display: "inline-block",
  },
  ".forte-spin::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    border: "1.5px solid rgba(255,255,255,0.2)",
    borderRadius: "45%",
  },
  ".forte-spin::after": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "50%",
    height: "2.5px",
    background: "linear-gradient(90deg, transparent 0%, #C29717 40%, #e8a520 100%)",
    transformOrigin: "0 0",
    animation: "forteSpin 1.4s linear infinite",
    boxShadow: "0 0 4px rgba(194,151,23,0.6), -2px 2px 0 rgba(255,255,255,0.08), -4px 4px 0 rgba(255,255,255,0.04), -6px 6px 0 rgba(255,255,255,0.02)",
  },
  "@keyframes forteSpin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
  ".rte-btn": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    cursor: "pointer",
    color: "#999",
    fontSize: "13px",
    borderRadius: "2px",
    "&:hover": {
      background: "rgba(255,255,255,0.08)",
      color: "#fff",
    },
  },
  ".rte-editor": {
    minHeight: "180px",
    padding: "10px 12px",
    color: "#ddd",
    fontSize: "13px",
    lineHeight: "1.7",
    outline: "none",
    background: "#2a2a2a",
    "& h3": {
      fontSize: "16px",
      fontWeight: 500,
      color: "#fff",
      margin: "8px 0 4px",
    },
    "& ul": {
      paddingLeft: "18px",
      margin: "4px 0",
    },
    "& li": {
      marginBottom: "2px",
    },
  },
  "::-webkit-scrollbar": {
    width: "4px",
    height: "4px",
  },
  "::-webkit-scrollbar-track": {
    background: "transparent",
  },

  /* Dialog improvements */
  ".MuiDialog-paper *": {
    fontFamily: '"Inter", sans-serif !important',
  },
  ".MuiDialog-paper .MuiInputBase-input": {
    color: "#fff !important",
    fontSize: "13px !important",
    backgroundColor: "#2a2a2a !important",
  },
  ".MuiDialog-paper .MuiInputLabel-root": {
    color: "#999 !important",
    fontSize: "13px !important",
  },
  ".MuiDialog-paper .MuiInputLabel-root.Mui-focused": {
    color: "#C29717 !important",
  },
  ".MuiDialog-paper .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255,255,255,0.22) !important",
  },
  ".MuiDialog-paper .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255,255,255,0.3) !important",
  },
  ".MuiDialog-paper .MuiSelect-select": {
    color: "#fff !important",
  },
  ".MuiDialog-paper .MuiTypography-root": {
    color: "#ddd !important",
  },
  ".MuiDialog-paper h5, .MuiDialog-paper h6": {
    color: "#fff !important",
  },
  ".MuiDialogActions-root .MuiButton-root": {
    minWidth: "90px !important",
    padding: "8px 20px !important",
    fontSize: "12px !important",
    letterSpacing: "0.5px !important",
  },
  ".MuiDialogActions-root .MuiButton-containedInfo, .MuiDialogActions-root .MuiButton-containedDark": {
    backgroundColor: "rgba(194,151,23,0.15) !important",
    color: "#C29717 !important",
    border: "1px solid rgba(194,151,23,0.3) !important",
  },
  ".MuiDialogActions-root .MuiButton-containedInfo:hover, .MuiDialogActions-root .MuiButton-containedDark:hover": {
    backgroundColor: "rgba(194,151,23,0.25) !important",
  },
  ".MuiDialogActions-root .MuiButton-outlinedSecondary, .MuiDialogActions-root .MuiButton-outlinedDark": {
    borderColor: "rgba(255,255,255,0.2) !important",
    color: "#ccc !important",
  },
  ".MuiDialogActions-root .MuiButton-outlinedSecondary:hover, .MuiDialogActions-root .MuiButton-outlinedDark:hover": {
    borderColor: "#fff !important",
    color: "#fff !important",
  },
  "::-webkit-scrollbar-thumb": {
    background: "#333",
    borderRadius: "2px",
  },
};

export default globals;
